import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
  mode: 'hash',
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/home/Home'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/my',
      name: 'My',
      component: () => import('@/pages/my/My'),
      meta: {
        authRequired: true
      }
    }, , {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('@/pages/dashboard/Dashboard'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/city',
      name: 'City',
      component: () => import('@/pages/city/City'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/login/Login'),
    }, {
      path: '/register',
      name: 'Register',
      component: () => import('@/pages/register/Register'),
    }, {
      path: '/detail/:id',
      name: 'Detail',
      component: () => import('@/pages/detail/Detail'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/contentadd',
      name: 'Contenta',
      component: () => import('@/pages/contentadd/Content'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/contentedit',
      name: 'ContentaEdit',
      component: () => import('@/pages/contentedit/Contentedit'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/public',
      name: 'Public',
      component: () => import('@/pages/public/Public'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/clock',
      name: 'Clock',
      component: () => import('@/pages/clock/Clock'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/count_clock',
      name: 'Count_clock',
      component: () => import('@/pages/count_clock/Count_clock'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/timecard',
      name: 'Timecard',
      component: () => import('@/pages/timecard/Timecard'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/project',
      name: 'Project',
      component: () => import('@/pages/project/Project'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/projectdetail/:id',
      name: 'ProjectDetail',
      component: () => import('@/pages/projectdetail/ProjectDetail'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/projectedit/:id',
      name: 'ProjectEdit',
      component: () => import('@/pages/projectedit/ProjectEdit'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/visitor',
      name: 'Visitor',
      component: () => import('@/pages/visitor/Visitor'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/addvisitor',
      name: 'AddVisitor',
      component: () => import('@/pages/addvisitor/AddVisitor'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/schedule',
      name: 'Schedule',
      component: () => import('@/pages/schedule/Schedule'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/scheduledetail',
      name: 'Scheduledetail',
      component: () => import('@/pages/schedule/Scheduledetail'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/opportunity',
      name: 'Opportunity',
      component: () => import('@/pages/opportunity/Opportunity'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/addopportunity',
      name: 'Addopportunity',
      component: () => import('@/pages/addopportunity/Addopportunity'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/followup',
      name: 'Followup',
      component: () => import('@/pages/followup/Followup'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/detailopportunity',
      name: 'Detailopportunity',
      component: () => import('@/pages/detailopportunity/Detailopportunity'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/addproject',
      name: 'Addproject',
      component: () => import('@/pages/addproject/Addproject'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/clocklist',
      name: 'Clocklist',
      component: () => import('@/pages/clocklist/Clocklist'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/addclock',
      name: 'Addclock',
      component: () => import('@/pages/addclock/Addclock'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/editvisitor',
      name: 'Editvisitor',
      component: () => import('@/pages/editvisitor/Editvisitor'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/userlist',
      name: 'Userlist',
      component: () => import('@/pages/userlist/Userlist'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/customer',
      name: 'Customer',
      component: () => import('@/pages/customer/Customer'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/fk_record',
      name: 'Fk_record',
      component: () => import('@/pages/customer/Fk_jl'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/on_business',
      name: 'On_business',
      component: () => import('@/pages/on_business/Business'),
      meta: {
        authRequired: true
      }
    }, {
      path: '/addbusiness',
      name: 'Addbusiness',
      component: () => import('@/pages/on_business/Addbusiness'),
      meta: {
        authRequired: true
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.authRequired) {
    if (to.name !== 'Login' && !token) {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

// 使用异步导入路由文件夹访问时页面只加载访问页的代码
// import Vue from 'vue'
// import Router from 'vue-router'
//
// Vue.use(Router)
//
// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'Hmoe',
//       component: () => import('@/pages/home/Home') // 使用异步导入路由文件夹
//     },
//     {
//       path: '/city',
//       name: 'City',
//       component: () => import('@/pages/city/City') // 使用异步导入路由文件夹
//     },
//     {
//       path: '/detail/:id',
//       name: 'Detail',
//       component: () => import('@/pages/detail/Detail')
//     }
//   ],
//   scrollBehavior (to, from, savedPosition) {
//     return {x: 0, y: 0}
//   }
// })



// WEBPACK FOOTER //
// ./src/router/index.js